class Util
	{

	static toLocalDate(source, incorrect='', from = 'yyyy-MM-dd', to = app.locale.dateFormat)
		{
		if (typeof source === 'string')
			{
			source = DateTime.fromFormat(source, from);
			}
		if (source === null || source === undefined || source.isValid === false)
			{
			return incorrect;
			}
		return source.toFormat(to);
		}

	static toDbDate(source, incorrect = null, from = app.locale.dateFormat, to = 'yyyy-MM-dd')
		{
		if (typeof source === 'string')
			{
			source = DateTime.fromFormat(source.trim(), from);
			}
		if (source === null || source === undefined || source.isValid === false)
			{
			return incorrect;
			}
		return source.toFormat(to);
		}

	static toLocalDt(source, from = 'yyyy-MM-dd HH:mm:ss', to = app.locale.dtFormat)
		{
		if (typeof source === 'string')
			{
			source = DateTime.fromFormat(source.trim(), from);
			}
		if (source === null || source === undefined || source.isValid === false)
			{
			return '';
			}
		return source.toFormat(to);
		}

	static fromDbDate(source='', incorrectValue = undefined, from = 'yyyy-MM-dd')
		{
			if (source === null) return incorrectValue;
			let dt = DateTime.fromFormat(source, from);
			if (dt.invalid === null) return dt;
			return incorrectValue;
		}

	static toDt(source, from = 'yyyy-MM-dd HH:mm:ss',){
		if (typeof source === 'string')
			{
			source = DateTime.fromFormat(source.trim(), from);
			}
		return source;
	}

	// static dateFormat(dtStr)
	// 	{
	// 	if (dtStr === undefined || dtStr === null)
	// 		{
	// 		return '';
	// 		}
	// 	let dt = moment(dtStr);
	// 	return dt.format('DD.MM.YYYY');
	// 	}
	//
	// static dtFormat(dtStr, isUtc = true)
	// 	{
	// 	if (dtStr === undefined || dtStr === null)
	// 		{
	// 		return '';
	// 		}
	// 	if (isUtc)
	// 		{
	// 		dtStr += '+00:00';
	// 		}
	// 	let dt = moment(dtStr).local();
	// 	return dt.format('DD.MM.YYYY HH:mm');
	// 	}

	/**
	 * @param {*} number count
	 * @param {*} titles ['', 'персона', 'персоны', 'персон']
	 * @returns 
	 */
	static spell(number, titles)
		{
		if (typeof number !== 'number')
			{
			number = parseInt(number);
			}
		let cases = [2, 0, 1, 1, 1, 2];
		let text;
		if (titles.length === 1)
			{
			text = titles[0];
			}
		if (number === 0)
			{
			text = titles[0];
			}
		else
			{
			titles.shift();
			text = titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
			}
		text = PF.H.applyContext(text, {v: number});
		return text;
		}

	static phoneMediator(value)
		{
		if(value === null || value === undefined)
			{
			return '';
			}
		value = value.replace(/\+7/, '');
		value = value.replace(/\D/g, '');
		value = value.substr(0, 10);

		if (value.length > 3)
			{
			value = value.substr(0, 3) + ' ' + value.substr(3, value.length);
			}
		if (value.length > 7)
			{
			value = value.substr(0, 7) + ' ' + value.substr(7, value.length);
			}
		if (value.length > 10)
			{
			value = value.substr(0, 10) + ' ' + value.substr(10, value.length);
			}
		value = '+7 ' + value;
		return value;
		}

	static fio(person)
		{
		if ('lname' in person && 'fname' in person && person.lname !== null && person.fname !== null)
			{
			return `${person.lname} ${person.fname} ${person.mname}`;
			}
		return '';
		}

	static legalName(legalEntity)
		{
		if (legalEntity.legalEntityType.code === 'person')
			{
			return Util.fio(legalEntity.person);
			}
		else if (legalEntity.legalEntityType.code === 'org')
			{
			return legalEntity.org.name + ` (${legalEntity.org.inn})`;
			}
		return '';
		}

	static fioShort(person)
		{
		if ('lname' in person && 'fname' in person)
			{
			let fname = PF.get(person, 'fname', '', '');
			fname = fname[0];
			if (fname !== '')
				{
				fname += '. ';
				}
			let mname = PF.get(person, 'mname', '', '');
			mname = mname[0];
			if (mname !== '')
				{
				mname += '.';
				}
			let fio = `${person.lname} ${fname} ${mname}`;
			fio = fio.trim();
			return fio;
			}
		return '';
		}

	static moneyFormat(intValue)
		{
		let value = intValue + "";
		for (let i = value.length - 5; i > 0; i -= 3)
			{
			value = value.substr(0, i) + ' ' + value.substr(i);
			}
		if (value.endsWith('00'))
			{
			value = value.substr(0, value.length - 2);
			}
		else
			{
			if (value !== '0')
				{
				value = value.substr(0, value.length - 2) + '.' + value.substr(value.length - 2);
				}
			}
		return value;
		}

	static ucfirst(str)
		{
		if (str.length)
			{
			str = str.charAt(0).toUpperCase() + str.slice(1);
			}
		return str;
		}

	static sizeFormat(bytes, si = true)
		{
		var thresh = si ? 1000 : 1024;
		if (Math.abs(bytes) < thresh)
			{
			return bytes + ' Б';
			}
		var units = si
			? ['КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ']
			: ['KiB', 'MiB', 'GiB', 'TiB',];
		var u = -1;
		do
			{
			bytes /= thresh;
			++u;
			}
		while (Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(1) + ' ' + units[u];
		}

	static decimalAdjust(type, value, exp)
		{
		if (typeof exp === 'undefined' || +exp === 0)
			{
			return Math[type](value);
			}
		value = +value;
		exp = +exp;
		if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
			{
			return NaN;
			}
		value = value.toString().split('e');
		value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
		value = value.toString().split('e');
		return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
		}

	static round(value, exp)
		{
		return PF.H.decimalAdjust('round', value, exp);
		}

	static ceil(value, exp)
		{
		return PF.H.decimalAdjust('ceil', value, exp);
		}

	static floor(value, exp)
		{
		return PF.H.decimalAdjust('floor', value, exp);
		}

    //https://active-vision.ru/blog/js-settimout-i-sleep-v-javascript/
	/**
	 * Выполнить через N времени
	 * ```
	 * Util.sleep(ms).then(() => { });
	 * ```
	 * @param {*} ms 
	 * @returns 
	 */
    static sleep(ms)
		{
		return new Promise(resolve => setTimeout(resolve, ms));
		}

	/**
	 * Повторять каждые N времени (бесполезная хрень)
	 * @param {*} time - в ms.
     * 5 сек 5000;
     * 5 мин 300000;
     * 10 мин 600000;
     * час 3600000.
	 * @param {*} callback 
	 * @param {*} errorCallback 
	 */
	static interval(time, callback, errorCallback) 
		{
			try
			{
				setInterval(() =>
				{
					callback()
				}, time);
			} catch (error)
			{
				console.log(error);
				errorCallback();
			}
		}

	static isJsonString(str)
		{
			try
			{
				JSON.parse(str);
			}
			catch (e)
			{
				return false;
			}
			return true;
		}

	static isFloat(n)
		{
			return Number(n) === n && n % 1 !== 0;
		}

    static isArray(data)
		{
			return Object.prototype.toString.call(data) == '[object Array]'
		}

	static browser()
		{
			let ua = navigator.userAgent;
			
			if (ua.search(/MSIE/) > 0) return 'Internet Explorer';
			if (ua.search(/Firefox/) > 0) return 'Firefox';
			if (ua.search(/Opera/) > 0) return 'Opera';
			if (ua.search(/Chrome/) > 0) return 'Google Chrome';
			if (ua.search(/Safari/) > 0) return 'Safari';
			if (ua.search(/Konqueror/) > 0) return 'Konqueror';
			if (ua.search(/Iceweasel/) > 0) return 'Debian Iceweasel';
			if (ua.search(/SeaMonkey/) > 0) return 'SeaMonkey';
			
			// Браузеров очень много, все вписывать смысле нет, Gecko почти везде встречается
			if (ua.search(/Gecko/) > 0) return 'Gecko';
		
			// а может это вообще поисковый робот
			return 'Search Bot';
		}

	}

window.Util = Util;